import React, { Component } from 'react';

import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import Select from './select';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ( {
    root: {
        minWidth: '90px'
    },
    selectedValue: {
        marginTop: 2
    }
} );
class Intervalpicker extends Component{
    changeInterval = ( event ) => {
        const selectedInterval = event.target.value;
        this.props.handleIntervalChange( selectedInterval );
    }

    render(){
        const { selectedInterval, classes, automationId, intervalOptions } = this.props;
        return (
            <FormControl data-automation-id={automationId} >
                <Select
                    value={selectedInterval}
                    onChange={this.changeInterval}
                    className="no-print"
                    renderValue={( value ) => <Typography variant="body1" classes={{ root: classes.selectedValue }}>{value}</Typography>}
                >
                    {
                        intervalOptions.map( ( option ) => {
                            return <MenuItem key={option.key} value={option.key}>{option.display}</MenuItem>;
                        } )
                    }
                </Select>
            </FormControl>
        );
    }
}

Intervalpicker.propTypes = {
    automationId: PropTypes.string,
    classes: PropTypes.object,
    handleIntervalChange: PropTypes.func.isRequired,
    intervalOptions: PropTypes.array.isRequired,
    selectedInterval: PropTypes.string.isRequired,
};


export default withStyles( styles )( Intervalpicker );
